//@ts-check

import React, { useState, useEffect } from "react"

// Material
import { makeStyles } from "@material-ui/core/styles"
import Popover from "@material-ui/core/Popover"

import EnterETHAddress from "./enter-eth-address"

/**
 * @param props {{
  anchorEl,
  handleClose,
  open,
  inputMethod,
  setCode,
  inputAddress,
  setInputAddress,
  chosenToken,
  setChosenToken,
  setCompilerVersion,
  loading_solidity_state,
  setLoadingSolidityState,
  onChange,
  mainnetRequestState,
  setMainnetRequestState,
  width,
  setFilesFromMainnet
 * }}
 */
const ImportPopover = function ({
  anchorEl,
  handleClose,
  open,
  inputMethod,
  setCode,
  inputAddress,
  setInputAddress,
  chosenToken,
  setChosenToken,
  setCompilerVersion,
  loading_solidity_state,
  setLoadingSolidityState,
  onChange,
  mainnetRequestState,
  setMainnetRequestState,
  width,
  setFilesFromMainnet
}) {

  // this determines whether there is a transparent background element
  // when this is `false`, the background is hidden by forcing its `position` to static
  const [isBackground, setIsBackground] = useState(true)

  useEffect(() => {
    if (open) {
      // upon opening popover, reset background `position` property
      // this allows correct positioning of the popover
      setIsBackground(true)
        // once popover has been positioned on the DOM, we remove the background
        // that makes it possible to click other elements without first closing the popover
        setTimeout(() => {
          setIsBackground(false)
        }, 0)
    }
  }, [open])

  // @ts-ignore
  const styles = makeStyles(theme => ({
    popoverRoot: ({ isBackground }) => ({
      position: isBackground ? "fixed" : "absolute !important",
    }),
    popoverPaper: ({ width }) => ({
      paddingBottom: theme.spacing(0.5),
      width: "500px",
      right: 0,
      // width,
      borderBottomRightRadius: 4,
      borderBottomLeftRadius: 4,
      transition: "none !important",
      transform: isBackground ? "none" : `translateY(${document.documentElement.scrollTop}px) !important`,
    }),
  }))

  const classes = styles({ width, isBackground })

  return (<Popover
    classes={{
      root: classes.popoverRoot,
      paper: classes.popoverPaper, // class name, e.g. `classes-nesting-root-x`
    }}
    open={open}
    anchorEl={anchorEl}
    onClose={() => setTimeout(() => handleClose(null), 500)}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
  >
    <EnterETHAddress
      inputMethod={inputMethod}
      setCode={setCode}
      inputAddress={inputAddress}
      setInputAddress={setInputAddress}
      chosenToken={chosenToken}
      setChosenToken={setChosenToken}
      setCompilerVersion={setCompilerVersion}
      loading_solidity_state={loading_solidity_state}
      setLoadingSolidityState={setLoadingSolidityState}
      onChange={onChange}
      mainnetRequestState={mainnetRequestState}
      setMainnetRequestState={setMainnetRequestState}
      closePopover={handleClose}
      isAutoSubmit={false}
      isInPopover={true}
      setFilesFromMainnet={setFilesFromMainnet}
    />
  </Popover>)
}

export default React.memo(ImportPopover)